// extracted by mini-css-extract-plugin
export default {"container":"taskActivitiesTitle_container__U-CtV","icon":"taskActivitiesTitle_icon__KGplk"};